import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getActivityDetail = async (params: object) => {
  return await GET({
    url: Api.getActivityDetail,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo'
    }
  })
}
export const getRankList = async (params: object) => {
  return await GET({
    url: Api.getRankList,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo'
    }
  })
}
export const getBonus = async (params: object) => {
  return await GET({ url: Api.getBonus, params, showError: false })
}
export const queryForAppDetail = async (params: object) => {
  return await GET({
    url: Api.queryForAppDetail,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      resourceKey: 'com.ishansong.control.service.ActivityForAppService.queryForAppDetail'

    }
  })
}
